import { Dtos } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useRequest } from "../../utils/request";
import { SuretyEntityIdMap } from "../types";
import { followersQueryKey } from "./followers.keys";

export const useFetchFollowers = <T extends keyof SuretyEntityIdMap>(
	url: string,
	type: T,
	id: SuretyEntityIdMap[T],
) => {
	const { get } = useRequest();
	const [isFollowing, setIsFollowing] = useState<boolean | undefined>();
	const { user } = useAuthenticatedUser();

	const { data, isLoading } = useQuery({
		queryKey: followersQueryKey(type, id),
		queryFn: async () => await get<Dtos.Follower.Get.Response[]>(url),
	});

	useEffect(() => {
		if (!!data) {
			setIsFollowing(data.some((follower) => follower.id === user.id));
		}
	}, [data]);

	return { followers: data, followersLoading: isLoading, isFollowing };
};
